import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { RegionService } from "../../services/RegionService";
import { mdlRegionListRequest } from "../../models/service-models/region/RegionListRequest";
import { mdlLanguage } from "../../models/ui-models/Language";

export type RegionSelectProps = {
    onChange?: Function;
    selectedLanguage?: mdlLanguage;
    cityId?: string;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
}

export const RegionSelect = memo(function RegionSelect(props: RegionSelectProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data && props.cityId){
            refetch();
        }
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getRegion"],
        () => {
            return RegionService.List({ cityId: props.cityId, currentLanguage: props.selectedLanguage?.value  });
        },
        {
            refetchOnWindowFocus: false,
            enabled: false
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    let countries = data?.body?.data;

    return (
        <>
            <Select
                mode={props.mode}
                loading={isLoading}
                onFocus={onFocus}
                size="middle"
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseRegion")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={countries?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
})